<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12">
        <v-tabs class="ma-2" v-model="activeTab" color="primary" dark>
          <v-tab>General</v-tab>
          <v-tab @click="showFieldIndex = -1">Fields</v-tab>
          <v-tab @click="showApiKeyIndex = -1">API Keys</v-tab>
          <v-tab-item>
            <v-container fluid>
              <v-row style="padding:20px;background:#e0e0e0;">
                <v-col cols="12">
                  <v-text-field
                    v-model="profile.name"
                    :counter="100"
                    label="Name"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="profile.description" :counter="200" label="Description"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid>
              <v-row style="background:#e0e0e0;">
                <v-col cols="12">
                  <v-card style="margin-top:10px">
                    <v-system-bar>
                      <span>Fields</span>
                    </v-system-bar>
                    <v-list>
                      <v-list-group
                        v-for="(field, index) in profile.fields"
                        :key="index"
                        style="border-bottom: 1px solid #ccc;"
                      >
                        <template v-slot:activator>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>{{ getFieldName(index) }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-btn class="ma-2" @click="deleteField(index)" icon ripple>
                                <v-icon color="error">delete</v-icon>
                              </v-btn>
                            </v-list-item-icon>
                          </v-list-item>
                        </template>
                        <v-container fluid style="padding: 0 30px;">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="field.name"
                                label="Name"
                                :counter="100"
                                :rules="nameRules"
                                required
                                @blur="updateFieldName(index, field.name)"
                              ></v-text-field>
                              <v-text-field
                                v-model="field.description"
                                :counter="200"
                                label="Description"
                              ></v-text-field>
                              <v-text-field
                                v-model="field.settings"
                                :counter="200"
                                label="Settings"
                              ></v-text-field>
                              <v-autocomplete
                                v-if="fieldTypes.length > 0"
                                :items="fieldTypes"
                                item-text="name"
                                item-value="id"
                                v-model="field.type"
                                label="Field type"
                                :rules="[v => fieldTypes.some(i => i.id == v) || 'this field is required']"
                                required
                              ></v-autocomplete>
                              <v-card v-if="field.type == 5">
                                <v-system-bar>
                                  <span>Items</span>
                                </v-system-bar>
                                <v-list>
                                  <v-list-group
                                    v-for="(fieldItem, fieldItemIndex) in field.items"
                                    :key="fieldItem.id"
                                  >
                                    <template v-slot:activator>
                                      <v-list-item-title>{{ getFieldItemName(index, fieldItemIndex) }}</v-list-item-title>
                                      <v-btn
                                        class="ma-2"
                                        @click="deleteFieldItem(index, fieldItemIndex)"
                                        icon
                                        ripple
                                      >
                                        <v-icon color="error">delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <v-list-item>
                                      <v-list-item-content>
                                        <v-container fluid>
                                          <v-row>
                                            <v-col cols="12">
                                              <v-text-field
                                                v-model="fieldItem.name"
                                                label="Name"
                                                :counter="100"
                                                :rules="nameRules"
                                                required
                                                @blur="updateFieldItemName(index, fieldItemIndex, fieldItem.name)"
                                              ></v-text-field>
                                              <v-text-field
                                                v-model="fieldItem.value"
                                                label="Value"
                                                :counter="100"
                                                :rules="nameRules"
                                                required
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list-group>
                                </v-list>
                                <v-card-actions>
                                  <div class="flex-grow-1"></div>
                                  <v-btn @click="addFieldItem(index)" color="success" small>
                                    add item
                                    <v-icon right dark>add</v-icon>
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                              <v-switch :label="`Required`" v-model="field.isRequired"></v-switch>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-list-group>
                    </v-list>
                  </v-card>
                  <v-btn class="ma-2" @click="addField()" color="success" small dark>
                    add field
                    <v-icon right dark>add</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid>
              <v-row style="background:#e0e0e0;">
                <v-col cols="12">
                  <v-card style="margin-top:10px">
                    <v-system-bar>
                      <span>API Keys</span>
                    </v-system-bar>
                    <v-list>
                      <v-list-group
                        v-for="(apiKey, index) in profile.apiKeys"
                        :key="index"
                        style="border-bottom: 1px solid #ccc;"
                      >
                        <template v-slot:activator>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>{{ getApiKeyName(apiKey.id) }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-btn class="ma-2" @click="deleteApiKey(index)" icon ripple>
                                <v-icon color="error">delete</v-icon>
                              </v-btn>
                            </v-list-item-icon>
                          </v-list-item>
                        </template>
                        <v-container fluid style="padding: 0 30px;">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="apiKey.description"
                                label="Description"
                                :counter="100"
                                :rules="nameRules"
                                required
                                @blur="updateApiKeyDescription(apiKey.id, apiKey.description)"
                              ></v-text-field>
                              <v-text-field
                                v-model="apiKey.startDate"
                                :counter="48"
                                label="Start date"
                              ></v-text-field>
                              <v-text-field v-model="apiKey.endDate" :counter="48" label="End date"></v-text-field>
                              <v-text-field
                                v-model="apiKey.key"
                                label="Key"
                                readonly
                                placeholder="auto generated"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-list-group>
                    </v-list>
                  </v-card>
                  <v-btn class="ma-2" @click="addApiKey()" color="success" small dark>
                    add API Key
                    <v-icon right dark>add</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-col>
      <v-col cols="12">
        <v-btn class="ma-2" color="primary" @click="submit">save</v-btn>
        <v-btn class="ma-2" color="primary" @click="back">cancel</v-btn>
        <span>{{submitStatus}}</span>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Sortable from "sortablejs";
import _ from "lodash";
export default {
  props: ["profile"],
  data: () => ({
    valid: true,
    activeTab: null,
    showFieldIndex: -1,
    showFieldItemIndex: -1,
    showApiKeyIndex: -1,
    submitStatus: null,
    showTriggerIndex: -1,
    triggerSources: [],
    actionTypes: [],
    showActionIndex: -1,
    showLookupIndex: -1,
    triggerNames: [],
    lookupNames: [],
    triggerActionNames: [],
    triggerActionTypes: [],
    fieldTypes: [],
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 100) || "100 characters maximum"
    ]
  }),
  computed: {
    orderedTriggers() {
      if (!this.profile.triggers) return [];
      return _.orderBy(this.profile.triggers, "order");
    }
  },
  methods: {
    orderedStepFields(stepid) {
      return _.orderBy(
        this.profile.steps.find(s => s.id == stepid).fields,
        "order"
      );
    },
    orderedTriggerActions(triggerid) {
      return _.orderBy(
        this.profile.triggers.find(t => t.id == triggerid).actions,
        "order"
      );
    },
    getTriggerActionName(triggerIndex, actionIndex) {
      var myName = this.triggerActionNames.find(
        x => x.ti == triggerIndex && x.ai == actionIndex
      );
      return myName ? myName.name : "";
    },
    getTriggerName(triggerIndex) {
      var myName = this.triggerNames.find(x => x.ti == triggerIndex);
      return myName ? myName.name : "";
    },
    getLookupName(lookupIndex) {
      var myName = this.lookupNames.find(x => x.li == lookupIndex);
      return myName ? myName.name : "";
    },
    updateLookupName(lookupIndex, lookupName) {
      this.lookupNames.find(x => x.li == lookupIndex).name = lookupName;
    },
    deleteTrigger(triggerIndex) {
      this.profile.triggers.splice(triggerIndex, 1);
      var deleteActions = this.actionNames.filter(x => x.ti == triggerIndex);
      if (deleteActions && deleteActions.length > 0) {
        deleteActions.forEach(x => {
          this.deleteAction(triggerIndex, x.id);
        });
      }
      this.getTriggerNameArrays();
    },
    deleteAction(triggerIndex, actionIndex) {
      this.profile.triggers[triggerIndex].actions.splice(actionIndex, 1);
      this.getTriggerNameArrays();
    },
    addTrigger() {
      if (!this.profile.triggers) {
        this.profile.triggers = [];
      }
      this.profile.triggers.push({ source: 0, actions: [] });
      this.showTriggerIndex = this.profile.triggers.length - 1;
      this.getTriggerNameArrays();
    },
    addLookup() {
      if (!this.profile.lookups) {
        this.profile.lookups = [];
      }
      this.profile.lookups.push({ schedule: 0 });
      this.showLookupIndex = this.profile.lookups.length - 1;
      this.getLookupNameArrays();
    },
    addTriggerAction(triggerIndex) {
      this.profile.triggers[triggerIndex].actions.push({ type: 0 });
      this.showActionIndex =
        this.profile.triggers[triggerIndex].actions.length - 1;
      this.getTriggerNameArrays();
    },
    getTriggerSources() {
      this.$http
        .get("api/identityprofiles/triggersources")
        .then(request => {
          this.triggerSources = request.data;
          this.getTriggerActionTypes();
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "2900", e);
        });
    },
    getTriggerActionTypes() {
      this.$http
        .get("api/identityprofiles/triggeractiontypes")
        .then(request => {
          this.triggerActionTypes = request.data;
          this.getTriggerNameArrays();
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "2901", e);
        });
    },
    setSortableActions() {
      this.profile.triggers.forEach((t, ti) => {
        let selectedAcionList = document.querySelector(
          "div.v-list.v-sheet.v-sheet--tile.theme--light.actionList" + ti
        );
        if (selectedAcionList != null) {
          const _self = this;
          Sortable.create(selectedAcionList, {
            group: ti,
            onEnd({ newIndex, oldIndex }) {
              let selectedActions = _self.profile.triggers[ti].actions;
              var selectedAction = selectedActions.splice(oldIndex, 1)[0];
              selectedActions.splice(newIndex, 0, selectedAction);
              _self.getStepNameArrays();
            }
          });
        }
      });
    },
    getTriggerNameArrays() {
      this.triggerNames = [];
      this.triggerActionNames = [];
      if (this.profile && this.profile.triggers) {
        this.showTriggerIndex = this.profile.triggers.length - 1
        this.profile.triggers.forEach((t, ti) => {
          this.triggerNames.push({
            ti: ti,
            name: this.triggerSources.find(ts => ts.id == t.source).name
          });
          t.actions.forEach((a, ai) => {
            a.order = ai;
            this.triggerActionNames.push({
              ti: ti,
              ai: ai,
              name: this.triggerActionTypes.find(tat => tat.id == a.type).name
            });
          });
        });
      }
    },
    getLookupNameArrays() {
      this.lookupNames = [];
      if (this.profile && this.profile.lookups) {
        this.showLookupIndex = this.profile.lookups.length - 1
        this.profile.lookups.forEach((l, li) => {
          this.lookupNames.push({ li: li, name: l.name });
        });
      }
    },
    testNewField() {
      if (this.$refs.form.validate()) {
        this.showFieldIndex = -1;
      }
    },
    addField() {
      this.profile.fields.push({ name: "", type: 0 });
      this.showFieldIndex = this.profile.fields.length - 1;
    },
    addFieldItem(fieldIndex) {
      this.profile.fields[fieldIndex].items.push({ name: "" });
      this.showFieldItemIndex =
        this.profile.fields[fieldIndex].items.length - 1;
    },
    getFieldName(fieldIndex) {
      return this.profile.fields[fieldIndex].name
    },
    getFieldItemName(fieldIndex, fieldItemIndex) {
      return this.profile.fields[fieldIndex].items[fieldItemIndex].name
    },
    updateFieldName(fieldIndex, fieldName) {
      this.profile.fields[fieldIndex].name = fieldName
    },
    updateFieldItemName(fieldIndex, fieldItemIndex, fieldItemName) {
      this.profile.fields[fieldIndex].items[
        fieldItemIndex
      ].name = fieldItemName;
    },
    deleteField(fieldIndex) {
      this.profile.fields.splice(fieldIndex, 1);
    },
    deleteFieldItem(fieldIndex, fieldItemIndex) {
      this.profile.fields[fieldIndex].items.splice(fieldItemIndex, 1);
    },
    testNewApiKey() {
      if (this.$refs.form.validate()) {
        this.showApiKeyIndex = -1;
      }
    },
    addApiKey() {
      this.profile.apiKeys.push({ description: "", key: "" });
      this.showApiKeyIndex = this.profile.apiKeys.length - 1;
    },
    getApiKeyName(apiKeyIndex) {
      return this.profile.apiKeys.find(x => x.id == apiKeyIndex).description;
    },
    updateApiKeyDescription(apiKeyIndex, apiKeyDescription) {
      this.profile.apiKeys.find(
        x => x.id == apiKeyIndex
      ).description = apiKeyDescription;
    },
    deleteApiKey(apiKeyIndex) {
      this.profile.apiKeys.splice(apiKeyIndex, 1);
    },
    reset() {
      this.$refs.form.reset();
    },
    submit() {
      if (!this.$refs.form.validate()) {
        this.submitStatus = "ERROR";
      } else {
        if (this.profile.id == undefined) {
          this.submitStatus = "POSTING";
          this.$http
            .post("api/assetprofiles/", this.profile)
            .then(request => {
              if (request.status == 201) {
                this.submitStatus = "OK";
                this.$emit("done");
              } else {
                this.submitStatus = "ERROR";
              }
            })
            .catch(e => {
              this.$root.$children[0].$emit("display-error", "2902", e);
              this.submitStatus = "ERROR";
            });
        } else {
          this.submitStatus = "PUTTING";
          this.$http
            .put("api/assetprofiles/" + this.profile.id, this.profile)
            .then(request => {
              if (request.status == 201) {
                this.submitStatus = "OK";
                this.$emit("done");
              } else {
                this.submitStatus = "ERROR";
              }
            })
            .catch((e) => {
              this.$root.$children[0].$emit("display-error", "2903", e);
              this.submitStatus = "ERROR";
            });
        }
      }
    },
    back() {
      this.$refs.form.reset();
      this.$emit("reset");
    },
    getFieldTypes() {
      this.$http
        .get("api/assetprofiles/fieldtypes")
        .then(request => {
          this.fieldTypes = request.data;
        })
        .catch(e => {
            this.$root.$children[0].$emit("display-error", "2904", e);
        });
    }
  },
  mounted: function() {
    this.getFieldTypes();
    this.getTriggerSources();
    this.getLookupNameArrays();
  }
};
</script>